import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { FeatureFlagService } from "../services/feature-flag.service";

@Injectable({
  providedIn: "root",
})
export class FeatureEnabledGuard implements CanActivate {
  constructor(private featureFlagService: FeatureFlagService, private router: Router) {}

  public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const featureFlag = route.data["featureFlag"];
    if (!featureFlag) return true;

    const isEnabled = await this.featureFlagService.asyncIsEnabled(featureFlag);
    return isEnabled ? true : this.router.navigate(["/"], {});
  }
}
